import React from 'react';
import PropTypes from 'prop-types';
import { Circle } from 'rc-progress';
const StatusLoader = ({
  loaded: _loaded = false,
  percentage: _percentage = 0
}) => /*#__PURE__*/React.createElement("div", {
  "data-testid": "statusLoader"
}, !_loaded && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, `Loading (${_percentage}%)...`), /*#__PURE__*/React.createElement(Circle, {
  percent: _percentage,
  strokeWidth: "4",
  strokeColor: "#D3D3D3"
})));
StatusLoader.propTypes = {
  loaded: PropTypes.bool,
  percentage: PropTypes.number
};
export default StatusLoader;